import React from "react";
import DeliveryHoursCalc from "./DeliveryHoursCalc";
import DeliveryTimeDayTypes from "./DeliveryTimeDayTypes";
import { useSelector, useDispatch } from "react-redux";
import * as actionType from "../../../store/action";

const DeliveryEdit = () => {
  const { regulaerDeliveryPrice, orderForFree } = useSelector((state) => ({
    regulaerDeliveryPrice: state.productsInCart.regulaerDeliveryPrice,
    orderForFree: state.productsInCart.orderForFree,
  }));
  const dispatch = useDispatch();

  const changeDeliveryPrice = (amount) => {
    dispatch({ type: actionType.SET_DELIVERY_PRICE, payload: amount });
  };

  const changeOrderForFree = (amount) => {
    dispatch({ type: actionType.SET_ORDER_FOR_FREE, payload: amount });
  };

  const handleDeliveryPriceInputChange = (event) => {
    const newValue = parseFloat(event.target.value);
    if (!isNaN(newValue)) {
      changeDeliveryPrice(newValue);
    }
  };

  const handleOrderForFreeInputChange = (event) => {
    const newValue = parseFloat(event.target.value);
    if (!isNaN(newValue)) {
      changeOrderForFree(newValue);
    }
  };

  return (
    <div className="delivery-time-edit">
      <div className="title-role">
        <h2>
          דמי משלוח:
          <div className="price-control">
            <button
              onClick={() => changeDeliveryPrice(regulaerDeliveryPrice - 1)}
            >
              -
            </button>
            <input
              type="number"
              className="price-input"
              value={regulaerDeliveryPrice}
              onChange={handleDeliveryPriceInputChange}
            />
            <button
              onClick={() => changeDeliveryPrice(regulaerDeliveryPrice + 1)}
            >
              +
            </button>
            <span> ₪</span>
          </div>
          | הזמנה למשלוח חינם:
          <div className="price-control">
            <button onClick={() => changeOrderForFree(orderForFree - 1)}>
              -
            </button>
            <input
              type="number"
              className="price-input"
              value={orderForFree}
              onChange={handleOrderForFreeInputChange}
            />
            <button onClick={() => changeOrderForFree(orderForFree + 1)}>
              +
            </button>
            <span> ₪</span>
          </div>
        </h2>
        <h1>עריכת זמני משלוח:</h1>
      </div>
      <DeliveryHoursCalc />
      <DeliveryTimeDayTypes />
    </div>
  );
};

export default DeliveryEdit;
